// 注册组件

// 上传组件
import Upload from './upload'

export default {
    Upload,
}
